import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	constructor() {}

	scrollTo(elem: string) {
		// Wait for element to exist
		const maxAttempts = 10;
		let attempts = 0;

		const tryScroll = () => {
			const element = document.querySelector(elem);
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest',
				});
			} else if (attempts < maxAttempts) {
				attempts++;
				setTimeout(tryScroll, 100); // Try again in 100ms
			}
		};

		tryScroll();
	}
}
